import { ArticleCardLocation } from '../../utilities/gtm';

export const getClampedTextStyles = (linesCount: number) => ({
  display: '-webkit-box',
  WebkitLineClamp: linesCount,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textWrap: 'balance',
  wordBreak: 'break-word',
});

export type ArticleCardVariant =
  | 'minimizedHighlight'
  | 'highlight'
  | 'mobile'
  | 'default';

export interface CardGTMData {
  readonly index?: number;
  readonly location?: ArticleCardLocation;
}
